"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetricsProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _sliReactMetrics = require("@cvent/sli-react-metrics");
var _initRudderstack = require("./initRudderstack");
var _propTypes = require("prop-types");
var _isDDsynthetics = _interopRequireDefault(require("../utils/isDDsynthetics"));
var _isAutomation = _interopRequireDefault(require("../utils/isAutomation"));
var _basePropertiesRegistry = require("./web/basePropertiesRegistry");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Application Metrics Component. Tracks application metrics to multiple destinations
 * including Data Dog, MixPanel, Intercom, etc via the Rudderstack SDK
 *
 * Note: Each reporter is responsible for checking the destination property passed in
 * the data of each action
 *
 *
 * @param param0
 * @returns
 */
var AppMetrics = function AppMetrics(_ref) {
  var children = _ref.children,
    environmentName = _ref.environmentName,
    baseData = _ref.baseData,
    cdpWriteKey = _ref.cdpWriteKey,
    cdpDataPlaneUrl = _ref.cdpDataPlaneUrl,
    metricsEnabled = _ref.metricsEnabled;
  (0, _react.useEffect)(function () {
    (0, _initRudderstack.initRudderStack)({
      metricsEnabled: metricsEnabled,
      writeKey: cdpWriteKey,
      dataPlaneUrl: cdpDataPlaneUrl,
      environmentName: environmentName
    });
  }, [metricsEnabled, cdpWriteKey, cdpDataPlaneUrl, environmentName]);
  var config = {
    environmentName: environmentName,
    metricsEnabled: metricsEnabled,
    skipDeprecatedDefaultPrefix: true
  };
  var isDDSynthetics = (0, _isDDsynthetics["default"])();
  var isAutomation = (0, _isAutomation["default"])();
  var reporters = isDDSynthetics || isAutomation ? [_sliReactMetrics.datadogReporter] : [_sliReactMetrics.rudderStackReporter, _sliReactMetrics.datadogReporter];
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "with-rudderstack-metrics-provider"
  }, /*#__PURE__*/_react["default"].createElement(_sliReactMetrics.ReactMetrics, {
    config: config,
    baseData: baseData,
    reporters: reporters
  }, children));
};
AppMetrics.propTypes = {
  children: _propTypes.element,
  environmentName: _propTypes.string,
  baseData: _propTypes.object,
  cdpWriteKey: _propTypes.string,
  cdpDataPlaneUrl: _propTypes.string,
  metricsEnabled: _propTypes.bool
};

/**
 * Metrics Provider. Sets up the application with performance and analytics metrics functionality
 * via the page actions api with CDP support. This component is intended to wrap your application's
 * main entry point component (usually the app.tsx file under the pages directory for nextJS apps)
 *
 * @param param0
 * @returns
 */
var MetricsProvider = exports.MetricsProvider = function MetricsProvider(_ref2) {
  var accountMappingId = _ref2.accountMappingId,
    environmentName = _ref2.environmentName,
    studioUserId = _ref2.studioUserId,
    persona = _ref2.persona,
    rudderstackWriteKey = _ref2.rudderstackWriteKey,
    rudderstackDataPlaneUrl = _ref2.rudderstackDataPlaneUrl,
    children = _ref2.children,
    appVersion = _ref2.appVersion,
    teamId = _ref2.teamId,
    broadcastId = _ref2.broadcastId,
    studioEventId = _ref2.studioEventId,
    sessionId = _ref2.sessionId,
    attendeeId = _ref2.attendeeId,
    sourceId = _ref2.sourceId,
    sessionStartDate = _ref2.sessionStartDate,
    sessionEndDate = _ref2.sessionEndDate,
    sessionName = _ref2.sessionName,
    broadcastType = _ref2.broadcastType,
    eventId = _ref2.eventId,
    eventName = _ref2.eventName,
    eventStartDate = _ref2.eventStartDate,
    eventEndDate = _ref2.eventEndDate,
    meetingType = _ref2.meetingType;
  var isAutomationAccount = (0, _isAutomation["default"])() || (0, _isDDsynthetics["default"])();
  // Application's metrics base properties. These properties will be sent as metadata for each action tracked.
  var baseData = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({
      // The current application version. Value should be grabbed from your app's package.json file
      appVersion: appVersion,
      // Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
      product: 'studio',
      // Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
      businessUnit: 'event',
      // Unique identifier to reference the application that is sending the action to the downstream tools
      component: 'studio',
      // Identifier to represent the user's characteristics
      persona: persona,
      accountMappingId: accountMappingId,
      environmentName: environmentName,
      isCVIIUser: false,
      studioUserId: studioUserId,
      ddUserId: studioUserId
    }, isAutomationAccount ? {
      userGroup: 'automation'
    } : {
      userGroup: 'unknown'
    }), {}, {
      broadcastId: broadcastId,
      teamId: teamId,
      studioEventId: studioEventId,
      sessionId: sessionId,
      attendeeId: attendeeId,
      sourceId: sourceId,
      sessionStartDate: sessionStartDate,
      sessionEndDate: sessionEndDate,
      sessionName: sessionName,
      broadcastType: broadcastType,
      isWebinar: broadcastType === 'Webinar',
      eventId: eventId,
      eventName: eventName,
      eventStartDate: eventStartDate,
      eventEndDate: eventEndDate,
      meetingType: meetingType
    });
  }, [appVersion, persona, accountMappingId, environmentName, studioUserId, isAutomationAccount, broadcastId, teamId, studioEventId, sessionId, attendeeId, sourceId, sessionStartDate, sessionEndDate, sessionName, broadcastType, eventId, eventName, eventStartDate, eventEndDate, meetingType]);
  var metricsEnabled = true;

  // Make base properties available to non-React code (e.g., Redux middleware, socket handlers)
  (0, _react.useEffect)(function () {
    (0, _basePropertiesRegistry.setBaseProperties)(baseData);
  }, [baseData]);
  return /*#__PURE__*/_react["default"].createElement(AppMetrics, {
    metricsEnabled: metricsEnabled,
    environmentName: environmentName,
    baseData: baseData,
    cdpWriteKey: rudderstackWriteKey,
    cdpDataPlaneUrl: rudderstackDataPlaneUrl
  }, children);
};
MetricsProvider.propTypes = {
  studioUserId: _propTypes.string,
  rudderstackWriteKey: _propTypes.string,
  rudderstackDataPlaneUrl: _propTypes.string,
  children: _propTypes.element,
  accountMappingId: _propTypes.string,
  environmentName: _propTypes.string,
  appVersion: _propTypes.string,
  teamId: _propTypes.string,
  broadcastId: _propTypes.string,
  studioEventId: _propTypes.string,
  sessionId: _propTypes.string,
  attendeeId: _propTypes.string,
  sourceId: _propTypes.string,
  sessionStartDate: _propTypes.string,
  sessionEndDate: _propTypes.string,
  sessionName: _propTypes.string,
  broadcastType: _propTypes.string,
  eventId: _propTypes.string,
  eventName: _propTypes.string,
  eventStartDate: _propTypes.string,
  eventEndDate: _propTypes.string,
  meetingType: _propTypes.string
};